import { CustomerDataTable } from "../../components/index";

const Customers = () => {
  return (
    <div className="datatable-crud">
      <div className="card">
        <CustomerDataTable />
      </div>
    </div>
  );
};

export default Customers;
